import React from 'react';

/**
 * Hub bulk-load switch. Sits on its own row so it does not break the field grid.
 */
const HubBulkLoadSetting = ({ enabled, disabled = false, readOnly = false, onChange }) => {
  const on = !!enabled;
  return (
    <div className="col-span-2 sm:col-span-4">
      <div
        className={`flex items-center justify-between gap-4 rounded-xl border px-3 sm:px-4 py-3 ${
          on ? 'border-blue-200 bg-blue-50/70' : 'border-gray-200 bg-gray-50'
        }`}
      >
        <div className="min-w-0">
          <div className="flex items-center gap-2">
            <p className="text-xs sm:text-sm font-semibold text-secondary">Bulk Load</p>
            <span
              className={`inline-flex px-1.5 py-0.5 rounded text-[10px] font-semibold border ${
                on
                  ? 'bg-white text-blue-800 border-blue-200'
                  : 'bg-white text-gray-500 border-gray-200'
              }`}
            >
              {on ? 'On' : 'Off'}
            </span>
          </div>
          <p className="mt-1 text-[11px] sm:text-xs text-gray-500 leading-relaxed">
            Bookings from this branch can keep the full article rate in freight. Loading and unloading percentages are not charged.
          </p>
        </div>
        {!readOnly && (
          <button
            type="button"
            role="switch"
            aria-checked={on}
            aria-label="Bulk Load"
            disabled={disabled}
            onClick={() => onChange && onChange(!on)}
            className={`relative inline-flex h-6 w-11 shrink-0 rounded-full border-2 border-transparent transition-colors ${
              disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'
            } ${on ? 'bg-buttonBg' : 'bg-gray-300'}`}
          >
            <span
              className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow transition ${
                on ? 'translate-x-5' : 'translate-x-0'
              }`}
            />
          </button>
        )}
      </div>
    </div>
  );
};

export default HubBulkLoadSetting;
